/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Letterpreviewtotalpaidlabelpt6Inputs */

const en_letterpreviewtotalpaidlabelpt6 = /** @type {(inputs: Letterpreviewtotalpaidlabelpt6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total pago até à data:`)
};

const pt_letterpreviewtotalpaidlabelpt6 = /** @type {(inputs: Letterpreviewtotalpaidlabelpt6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total pago até à data:`)
};

/**
* | output |
* | --- |
* | "Total pago até à data:" |
*
* @param {Letterpreviewtotalpaidlabelpt6Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const letterpreviewtotalpaidlabelpt6 = /** @type {((inputs?: Letterpreviewtotalpaidlabelpt6Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Letterpreviewtotalpaidlabelpt6Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_letterpreviewtotalpaidlabelpt6(inputs)
	return pt_letterpreviewtotalpaidlabelpt6(inputs)
});
export { letterpreviewtotalpaidlabelpt6 as "letterPreviewTotalPaidLabelPT" }